import { GetterTree } from 'vuex'
import orderBy from 'lodash/orderBy'
import { CompanyState, UICompanyModel } from './companies.model'

export enum GetterTypes {
  GET_SORTED_COMPANIES = 'GET_SORTED_COMPANIES',
  GET_ACTIVE_COMPANY = 'GET_ACTIVE_COMPANY'
}

interface Getters {
  [GetterTypes.GET_SORTED_COMPANIES](state: CompanyState): Array<UICompanyModel>
}

export const getters: GetterTree<CompanyState, unknown> & Getters = {
  [GetterTypes.GET_SORTED_COMPANIES](state) {
    return orderBy(state.companies, ['lastShared'], ['desc'])
  }
}
